import { JsonPipe } from '@angular/common';
import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit, ViewContainerRef } from '@angular/core';
import { ViewEncapsulation,ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'app/App Store/state';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';

@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.scss'],
encapsulation: ViewEncapsulation.None,
})
export class ProjectListComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  @ViewChild('name') inputName;

  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  
  isFilter:boolean=false
  // column header
  public columns = [
    { name: "Project Name", prop: "name" },
    { name:"Catagory",prop:"catagory"},
    { name: "Actions", prop: "Actions" },
  ];

  // private
  private tempData = [];
  imageUrl=environment.apiUrls.imageUrl;

  project_id:any
  user_role:any

  jobs_data:any
  row_name:any
  row_prop:any
  row_value:any
  
  alert_list=[
    {id:'yes', name:'Yes'},
    {id:'no', name:'No'},
  ]
  alert_event:any
  lastAudit:any
  catId='6319d5025ab9e462a96cfbba'
  technology_List=[]
  selectedTechnology:any=null
  project_type:any
  guideline_data:any
  pageNumberSubscription : Subscription
  constructor(public apiService:ApiService,
              private modalService: NgbModal,
              private changeDetectorRef: ChangeDetectorRef,
              public toastr: ToastrService,private router : Router,
              private spinner: NgxSpinnerService,private activatedRoute: ActivatedRoute,private store: Store<AppState>) { 

              this.user_role=JSON.parse(localStorage.getItem('user'))
              let setting_data = JSON.parse(localStorage.getItem('setting-record'))
              let key_data = setting_data.filter((item) => item.key == 'Job Audit')
              this.guideline_data = key_data[0]?._id
              this.project_type='All'

              this.activatedRoute.queryParamMap.subscribe((params) => {
                let page = +params.get('page');
                this.setPage(page)
              });
              this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
              .subscribe(pageNumber => {
                this.page.pageNumber = pageNumber;
                if(pageNumber !==undefined){
                  this.page.pageNumber = pageNumber -1
                }
                if(pageNumber === 0) this.page.pageNumber = 0
                
              });
              this.getJobsList()

    
              }

  ngOnInit(): void{
    this.getUserById()
    this.getTechnologyList()
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
  getJobsList(){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
      this.apiService.getJobsByStatus('6428038677a2ab2fb559dc36',this.page.pageNumber+1,this.limitRef,'644a5c52af0db342c32eeaf8','current').subscribe((res:any)=>{
      this.spinner.hide();
      this.rows=res.data.items
      this.page.totalPages=res.data.totalCount
      
    })
  }
pageChangeData(page:any){
  this.router.navigate([], {
    relativeTo: this.activatedRoute,
    queryParams: { page: page.offset +1 },
    queryParamsHandling: 'merge' // keep existing query params
  });
  this.apiService.getJobsByStatus('6428038677a2ab2fb559dc36',page.offset+1,this.limitRef,'644a5c52af0db342c32eeaf8','current').subscribe((res:any)=>{
    this.setPage(page.offset +1)
    this.rows=res.data.items
    this.page.totalPages=res.data.totalCount
  })
}
getTechnologyList(){
  this.apiService.getTagByTagCatgoryId(this.catId).subscribe((res:any)=>{
    this.technology_List=res.data.slice(0, 4)
    let list={_id:'all',displayname:'All'}
    this.technology_List.push(list)
    this.technology_List.sort((a, b) => {
      if (a.displayname < b.displayname) { return -1; }
      if (a.displayname > b.displayname) { return 1; }
      return 0;
    });
  })
 }
getFilterProject(data){
  let search=data
  if(search){
    this.apiService.getFilterJobs(search).subscribe((res:any)=>{
      this.rows=res.data
    })
  }
}
resetFilter() {
  this.inputName.nativeElement.value = null;
  this.getJobsList()
}
  deleteProject(){
    if(this.project_id){
      this.apiService.projectDelete(this.project_id).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.getJobsList()
       
        }
        else{
          this.toastr.error(res.error)
        } 
        })
    }
    else{
      this.toastr.error('something went wrong !!')
    }
  }
  // ================== Delete Alert ========================
  ConfirmColor(id:any) {
    this.project_id=id
    swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes, delete it!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then( (result)=> {
      if (result.value) {  
        this.deleteProject()      
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your imaginary file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your imaginary file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  
  // ==========================================

  openModal(content,data,rowName,prop,rowValue,alertVal,lastAuditVal) {

    this.jobs_data=data
    this.row_name=rowName
    this.row_prop=prop
    this.row_value=rowValue
    this.alert_event=alertVal
    this.lastAudit=lastAuditVal
    const modalRef = this.modalService.open(content);
   
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  selectAlert(event){
    this.alert_event
  }

  updateRow(){
    let name=''
    name=this.row_prop
    let body={
      [name]: {
        name:this.row_value,
        alert : this.alert_event,
        lastaudit : this.lastAudit
      },

    }
    this.apiService.updateJob(this.jobs_data?._id,body).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.getJobsList()
        this.modalService.dismissAll()
      }
    })
  }
  editJob(row){
    this.router.navigate(['project-edit/:id',row?._id])
  }
  getUserById() {
    this.apiService.getUserbyId(this.user_role.id).subscribe((res: any) => {
      let emp_data=res?.data
      this.selectedTechnology=emp_data?.technology[0]?.displayname
      if(emp_data?.technology.length==0){
        this.selectedTechnology='All'
      }
    })
  }
  getTechnologyId(event_id,event_name){
    this.selectedTechnology=event_name
    if(event_id.displayname !=='All' && this.selectedTechnology){
      let formData=new FormData();
      formData.append('technology',event_id)
      this.apiService.updateUser(this.user_role.id,formData).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.getJobsList()
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
      else{
      let formData=new FormData();
        formData.append('technology',event_id._id)
        this.apiService.updateUser(this.user_role.id,formData).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.getJobsList()
          }
          else{
            this.toastr.error(res.error)
          }
        })
      }
     
   }
 
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }

}
